/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */

export type PushReportConfigurationFrequency =
    (typeof PushReportConfigurationFrequency)[keyof typeof PushReportConfigurationFrequency];

export const PushReportConfigurationFrequency = {
    Date: "Date",
    Weekly: "Weekly",
    Monthly: "Monthly",
} as const;
